import React, { useState } from "react";
import { withLocalize } from "react-localize-redux";
import footer from "../../translations/footer.json";
import { Translate } from "react-localize-redux";
import { langs } from "../../translations/translateJsonFile";
import "../../styles/diverseForce/footer.scss";
import "../../styles/app.scss";
import "../../styles/color.scss";
import { useDetectClickOutside } from "react-detect-click-outside";
import Dropdown from "react-bootstrap/Dropdown";
import BaseButton from "../../elementKit/baseButton/BaseButton";
import styled from "styled-components";
import { ReactComponent as LanguageIcon } from "../../assets/common/language.svg";
import { ReactComponent as InstagramLogo } from "../../assets/socials/instagram-black.svg";
import { ReactComponent as FacebookLogo } from "../../assets/socials/facebook-black.svg";
import { ReactComponent as TwitterLogo } from "../../assets/socials/twitter-black.svg";
import { ReactComponent as LinkedinLogo } from "../../assets/socials/linkedin-black.svg";

const StyledFooter = styled.div`
	${(props) => `
		.customizable-text {
			color: ${props.textColor} !important;
		}
		.policy-text {
			color: ${props.textColor}8C !important;
		}
		.social-icon {
			fill: ${props.textColor} !important;
		}
  			`};
`;

const DiverseForceFooter = (props) => {
	props.addTranslation(footer);
	const { certificateLanguages, certificateLanguageCodes } = langs;
	const [langClicked, setLangClicked] = useState(false);

	const handleLangClick = () => {
		setLangClicked((prevState) => !prevState);
	};
	const langMenuRef = useDetectClickOutside({
		onTriggered: langClicked ? handleLangClick : null,
	});
	const changeLang = (code) => {
		let arr = window.location.href.split("/");
		arr[3] = code;
		let adress = arr.reduce((a, b) => a + "/" + b);
		// setActiveLanguage(code);
		window.location.replace(adress);
	};

	return (
		<StyledFooter textColor={props.config.footerTextColor}>
			<div
				className="footer-main-out"
				style={{
					backgroundColor: props.config.footerBackgroundColor,
				}}
			>
				<div className="flex-column footer-main">
					<div className="footer-top">
						<img
							alt="verified"
							className="org-logo"
							src={props.config.logoLink}
						/>
						{props.config.footerMenu?.length ? (
							<div className="menu-items">
								{props.config.footerMenu.map((item) => (
									<a
										href={item.link}
										target="_blank"
										rel="noreferrer"
										className="single-menu-item customizable-text"
									>
										{item.text}
									</a>
								))}
							</div>
						) : null}
						{props.config.socials.length ? (
							<div className="flex-row socials">
								{props.config.socials.map((social) => (
									<a key={social.link} href={social.link} target="_blank">
										{social.type === "instagram" ? (
											<InstagramLogo className="social-icon" />
										) : null}
										{social.type === "facebook" ? (
											<FacebookLogo className="social-icon" />
										) : null}
										{social.type === "twitter" ? (
											<TwitterLogo className="social-icon" />
										) : null}
										{social.type === "linkedin" ? (
											<LinkedinLogo className="social-icon" />
										) : null}
									</a>
								))}
							</div>
						) : null}
					</div>
					<div className="hl"></div>
					<div className="footer-bottom">
						<div className="left">
							<a
								className="s5 policy-text"
								href={`https://verified.sertifier.com/${
									props.activeLanguage ? props.activeLanguage.code : "en"
								}/privacy-policy/`}
								target="_blank"
							>
								<Translate id="privacyPolicy" />
							</a>

							<a
								className="s5 policy-text"
								href={`https://verified.sertifier.com/${
									props.activeLanguage ? props.activeLanguage.code : "en"
								}/terms-of-use/`}
								target="_blank"
							>
								<Translate id="termsOfUse" />
							</a>
						</div>
						<Dropdown
							id="dropdown-basic-button"
							onSelect={(langCode) => {
								changeLang(langCode);
							}}
						>
							<Dropdown.Toggle>
								<BaseButton
									type="secondary"
									size="small"
									loading={false}
									backgroundColor={props.config.primaryColor}
								>
									<LanguageIcon className="lang-icon customizable-icon" />
									<span>
										{props.activeLanguage ? props.activeLanguage.name : ""}
									</span>
								</BaseButton>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{certificateLanguages.map((language) => (
									<Dropdown.Item eventKey={language.code} key={language.code}>
										{language.name}
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
			</div>
		</StyledFooter>
	);
};

export default withLocalize(DiverseForceFooter);
